<script>
  import { layoutMethods, billsPaymentMethods, exportMethods } from "@/state/helpers";
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Billspayment Provider List component
   */
  export default {
    page: {
      title: "Bills Payment Provider"
    },
    components: {
    },
    computed: {
    },
    data() {
      return {
        title: "Bills Payment Provider",
        searchValue: {
            search: null,
            searchField: null,
            page: 1,
            rows: 10,
            sort: 'id',
            orderDesc: true,
            status: null,
        },
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Provider Code', value: "provider_code" },
          { text: 'Provider Name', value: "provider_name" },
        ],
        fields: [
          { key: "provider_code", label: "Provider Code", sortable: true},
          { key: "provider_name", label: "Provider Name", sortable: true},
          { key: "description", label: "Description", sortable: false},
          { key: "status", label: "Status", sortable: true},
          { key: "api_endpoint", label: "API Endpoint", sortable: false}
        ], 
        statusList: [
          { text: 'All', value: null },
          { text: 'Active', value: 1 },
          { text: 'Inactive', value: 0 },
        ],
        totalProvider: 0,
        listProvider:[],
        sortBy: "value",
        sortDesc: false,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        billsPaymentProvider: {
          access: {
            create: true,
            read: true,
            update: true,
            delete: true
          }
        }
      };
    },
    methods: {
      ...layoutMethods,
      ...billsPaymentMethods,
      ...exportMethods,
      exportLogs(){
        this.isOpen = false;
        console.log(this.searchValue);
        var params = {
          ...this.searchValue,
          module: 'bills_payment_provider',
          email: JSON.parse(localStorage.getItem('userData')).email
        }
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      addBillsPaymentProvider(){
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Bills Payment Provider Form", params: { providerId: 0}
          }
        );
      },
      refresh(){
       this.onSearch();
      },
      async onSearch(state=''){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        console.log(":: search value ::",JSON.stringify(this.searchValue));
        await this.actionBillsPaymentProvider({
            action: "list",
            body: this.searchValue
        })
        .then((res) => {
          this.totalProvider = res["message"]["pageInfo"]["total"] 
          this.listProvider = res["message"]["rows"]
          console.log(res);
        }).catch((e)=>{
          console.log("error while getting list",e);
        });
      },
      tableSorting(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        this.onSearch('reset');
      },
    },
    async mounted(){
      this.changeTitle({title: 'Bills Payment Provider'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Bills Payment Provider', to: { name: 'Bills Payment Provider'} }
        ]
      });
      await this.onSearch();

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'Bills Payment', 'Bills Payment Provider')
        .then((access) => this.billsPaymentProvider.access = access);
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    <span class="fw-normal ms-lg-2"> {{ totalProvider }} </span> Record(s)
                                </h5>
                            </div>
                        </div>
                        <!-- end col record display--> 
                        <div class="col-md-8 col-sm-8">
                            <div class="d-flex justify-content-lg-end mb-lg-3">
                                <a v-if="billsPaymentProvider.access.create" class="btn btn-primary me-2" @click="addBillsPaymentProvider">
                                  <i class="uil uil-plus me-1"></i> Add Provider
                                </a>
                                 <b-button variant="primary" type="button" @click="exportLogs" class="px-2 me-2 btn btn-primary h-fit">
                                    <i class='uil uil-export me-1'></i> Export
                                  </b-button>
                                <a class="btn btn-secondary"
                                  @click="refresh"
                                    ><feather
                                    type="refresh-ccw"
                                    size="16"
                                    class="icon nav-icon"
                                    ></feather
                                    >&nbsp;&nbsp; Refresh</a
                                >
                            </div>
                        </div>
                        <!-- end col-8 --> 
                        <div class="row">
                          <div class="w-auto mb-5">
                            <div class="d-flex mt-3 mb-3">
                              <div class="me-3">
                                <form class="d-flex" @submit.prevent="onSearch('reset')">
                                  <b-form-group id="input-group-3" label-for="input-3">
                                    <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.searchField" :options="searchOptions"></b-form-select>
                                  </b-form-group>
                                  <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                                    <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                                    <b-form-input id="input-keyword" v-model="searchValue.search" class="rounded-0" style="width: auto"></b-form-input>
                                  </b-form-group>
                                </form>
                              </div>
                              <div class="col-md-3 ta-right">
                                <b-form-group label-for="reward-status" description="Filter by status">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                                    id="reward-status"
                                    v-model="searchValue.status"
                                    :options="statusList"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                              <div class="col-md-3 ta-right">
                                <b-form-group label="">
                                  <b-button variant="primary" type="button" @click="onSearch('reset')" class="px-2 me-2">
                                    <i class='bx bx-search bx-fw'></i>
                                    Search
                                  </b-button>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end search div--> 

                        <div class="table-responsive">
                          <div class="table align-middle table-nowrap">
                            <b-table
                              :items="listProvider"
                              :fields="fields"
                              responsive="sm"
                              :current-page="searchValue.page"
                              :sort-by.sync="sortBy"
                              :sort-desc.sync="sortDesc"
                              @sort-changed="tableSorting"
                              class="table-check"
                            >
                              <template #cell(provider_code)="data">
                                {{ data.item.providerCode }}
                              </template>
                              <template #cell(provider_name)="data">
                                <span class="text-body m-0 text-capitalize">
                                  <router-link :to="{ name: 'Bills Payment Provider Form', params: { providerId : data.item.providerId }}" 
                                  class="customer-name">
                                    {{ data.item.providerName}}
                                  </router-link>
                                </span>
                              </template>
                              <template #cell(description)="data">
                                <span class="text-body m-0 text-capitalize">
                                    {{ data.item.description}}
                                </span>
                              </template>
                              <template #cell(status)="data">
                                  <span class="text-success" v-if="data.item.providerStatus == 1">
                                    Active
                                  </span>
                                  <span class="text-danger" v-else>
                                    Inactive
                                  </span>
                              </template>
                              <template #cell(api_endpoint)="data">
                                <span class="text-body m-0">
                                    {{ data.item.apiEndpoint}}
                                </span>
                              </template>
                            </b-table>
                          </div>
                        </div>
                        <div class="row g-0 text-center" v-if="totalProvider == 0">
                          <span>No data to display.</span>
                        </div>
                        <div class="row" v-if="totalProvider > 0 && totalProvider > searchValue.rows">
                          <div class="col">
                            <div class="form-group row pull-left">
                              <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                              <div class="col-sm-6">
                                <b-form-group label-for="display-record">
                                  <b-form-select class="form-select shadow-none w-fit"
                                    id="display-record"
                                    v-model="searchValue.rows"
                                    :options="pageOptions"
                                    @change="onSearch('reset')"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                            </div>
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <b-pagination
                                v-if="totalProvider != 0 && totalProvider > searchValue.rows"
                                class="pagination-rounded"
                                v-model="searchValue.page"
                                :total-rows="totalProvider"
                                @input="onSearch()"
                                :per-page="searchValue.rows"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- end row -->
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>